import { render, staticRenderFns } from "./PriceTypeForm.vue?vue&type=template&id=7bb9e12a&scoped=true"
import script from "./PriceTypeForm.vue?vue&type=script&lang=ts"
export * from "./PriceTypeForm.vue?vue&type=script&lang=ts"
import style0 from "./PriceTypeForm.vue?vue&type=style&index=0&id=7bb9e12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb9e12a",
  null
  
)

export default component.exports